<template>
    <div class="contenedor-registrar-nuevo-oficio-autorizacion">
        <v-form
        ref="registrarNuevoOficio"
        v-model="formularioValido">
            <v-card>
                <v-card-title class="secondary--text">
                    Registrar nuevo oficio de autorización
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    @click="cerrar">
                    <v-icon class="secondary--text" large>highlight_off</v-icon>
                </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="6">
                            <custom-select
                            v-model="oficio.tipo"
                            label="Tipo*"
                            :items="itemsTipos"
                            item-text="tipo"
                            item-value="tipo"
                            :rules="[mixReglas.requerido]"
                            required
                            >
                            </custom-select>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                        <custom-date-picker
                            v-model="oficio.fecha"
                            cols="12"
                            label="Fecha*"
                            :rules="[mixReglas.requerido]"
                            required
                        >
                        </custom-date-picker>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="6">
                            <custom-text-field
                            v-model="oficio.numero"
                            label="Número*"
                            :rules="[mixReglas.requerido]"
                            required
                            >
                            </custom-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <custom-text-field
                            v-model.number="oficio.importe"
                            label="Importe*"
                            es-dinero
                            prefix="$"
                            :rules="[mixReglas.requerido]"
                            required
                            >
                            </custom-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" md="6">
                        <custom-date-picker
                            v-model="oficio.fechaRecibido"
                            cols="12"
                            label="Fecha Recibido"
                        >
                        </custom-date-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                        <custom-date-picker
                            v-model="oficio.fechaVencimiento"
                            cols="12"
                            label="Fecha Vencimiento"
                        >
                        </custom-date-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider class="bkground" />
                <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="mixAgregarOficio"
                    :disabled="!formularioValido || enviandoFormulario"
                    :loading="enviandoFormulario"
                    tipo="formAceptar"
                    label="Guardar">
                </custom-button>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixOficiosAutorizacion from '@/components/administracion/programacion/oficiosautorizacion/mixOficiosAutorizacion';

export default {
  name: 'registrarNuevoOficioAutorizacion',
  mixins: [
    mixOficiosAutorizacion,
  ],
  components: {
    CustomDatePicker,
    CustomSelect,
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      oficio: {
        tipo: '',
        numero: '',
        fecha: null,
        importe: null,
        fechaRecibido: null,
        fechaVencimiento: null,
      },
      itemsTipos: [
        { tipo: 'AUTORIZACIÓN', valor: 1 },
        { tipo: 'CANCELACIÓN', valor: 2 },
      ],
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoOficio.reset();
    },
  },
};
</script>
<style lang="scss">

</style>
